import apiClient from 'services/api';

export const getMessageThread = (viewToken: string) =>
  apiClient.get<Kudable.MessageThreadData>(
    `/public/messages/thread/${viewToken}`,
  );

export const clientMessageReply = (viewToken: string, body: string) =>
  apiClient.post<{ ok: boolean }>(
    `/public/messages/thread/${viewToken}/reply`,
    { body },
  );
